import { lazyRouteComponent } from "@tanstack/react-router";
import { createElement } from "react";

import type { PageDef } from "@/app/registry";
import { LegalPage } from "@/site/legal/LegalPage";
import { LEGAL_DOCS } from "@/site/legal/docs";

/**
 * Public company and policy pages (about, contact, pricing, services, FAQ, free trial, terms, privacy,
 * refunds, delivery, disclaimer). Payment partners check for these. They work
 * signed out and bring the public site's frame, so `pages` is empty.
 */
export const pages: PageDef[] = [];

export const publicPages: PageDef[] = [
  ...LEGAL_DOCS.map((doc) => ({
    path: `/${doc.slug}`,
    title: doc.title,
    component: () => createElement(LegalPage, { doc }),
  })),
  {
    path: "/contact",
    title: "Contact us",
    component: lazyRouteComponent(() => import("@/site/legal/ContactPage"), "ContactPage"),
  },
  {
    path: "/pricing",
    title: "Pricing",
    component: lazyRouteComponent(() => import("@/site/legal/PricingPage"), "PricingPage"),
  },
  {
    // the Research Analyst plans (V063)
    path: "/for-research-analysts",
    title: "For Research Analysts",
    component: lazyRouteComponent(() => import("@/site/legal/ForResearchAnalystsPage"), "ForResearchAnalystsPage"),
  },
  {
    path: "/faq",
    title: "Frequently asked questions",
    component: lazyRouteComponent(() => import("@/site/legal/FaqPage"), "FaqPage"),
  },
  {
    path: "/services",
    title: "Services",
    component: lazyRouteComponent(() => import("@/site/legal/ServicesPage"), "ServicesPage"),
  },
  {
    path: "/free-trial",
    title: "Free trial",
    component: lazyRouteComponent(() => import("@/site/legal/FreeTrialPage"), "FreeTrialPage"),
  },
];
